import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { AdminOptionsNav } from '../admin-options-nav';
import {
  GoogleAnalyticsSectionId,
  GOOGLE_ANALYTICS_SECTION_REGISTRY,
  getGoogleAnalyticsSectionPath,
  isGoogleAnalyticsSectionRouteActive,
} from './molecules/ga-section-registry/ga-section.registry';

@Component({
  selector: 'admin-google-analytics',
  imports: [AdminOptionsNav, RouterLink, RouterOutlet],
  templateUrl: './admin-google-analytics.html',
  styleUrl: './admin-google-analytics.scss',
  host: { class: 'block h-full w-full min-w-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminGoogleAnalytics {
  private readonly router = inject(Router);

  readonly sections = GOOGLE_ANALYTICS_SECTION_REGISTRY;

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects.split('?')[0] ?? ''),
      startWith(this.router.url.split('?')[0] ?? ''),
    ),
    { initialValue: this.router.url.split('?')[0] ?? '' },
  );

  getSectionLink(sectionId: GoogleAnalyticsSectionId): string {
    return getGoogleAnalyticsSectionPath(sectionId);
  }

  isSectionSelected(sectionId: GoogleAnalyticsSectionId): boolean {
    return isGoogleAnalyticsSectionRouteActive(sectionId, this.currentUrl());
  }

  getSectionNavClass(sectionId: GoogleAnalyticsSectionId): string {
    return this.isSectionSelected(sectionId)
      ? 'border-primary/50 bg-primary/10 ring-1 ring-primary/35 dark:border-primary/45 dark:bg-primary/15 dark:ring-primary/25'
      : 'border-transparent hover:border-zinc-300 hover:bg-zinc-50 dark:hover:border-zinc-700 dark:hover:bg-zinc-900/50';
  }
}
